// extracted by mini-css-extract-plugin
export default {"loader":"ProcessingStage_loader__DfPFE","loaderText":"ProcessingStage_loaderText__YNhWS","banner":"ProcessingStage_banner__F6RhT","bannerText":"ProcessingStage_bannerText__1ok48"};